import { 
    CHECK_ECARD_SUCCESS,
    CHECK_ECARD_ERROR,
} from '../actions';

const initialState = {
    data: null,
    error: false,
};

function ecardReducer(state = initialState, action) {
    switch(action.type) {
        case CHECK_ECARD_SUCCESS:
            return Object.assign({}, state, {error: false});
        case CHECK_ECARD_ERROR:
            return Object.assign({}, state, {error: true});
        default:
            return state;
    }
}

export default ecardReducer;